import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { ReactSelectInput } from '@hivebrite/design-system/Inputs';

import { useQueryNationalities } from 'hb-react/shared/hooks/useQueryNationalities';

const ReactSelectNationalities = ({ options = [], placeholder, ...props }) => {
  const { data, isLoading } = useQueryNationalities();

  return (
    <ReactSelectInput
      options={isEmpty(options) ? data : options}
      placeholder={placeholder || I18n.t('web.users.search.nationalities')}
      isLoading={isLoading}
      {...props}
    />
  );
};

ReactSelectNationalities.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.array,
};

export default ReactSelectNationalities;
